import axios from "axios";

// export async function fetchApi(endpoint, method = "GET", data = null) {
// 	  try {
// 		      const response = await axios({
// 			            method,
// 			            url: `${process.env.REACT_APP_API_URL}/${endpoint}`,
// 			            ...(data && { data }), // only include data if it exists
// 			          });

// 		      return response.data;
// 		    } catch (error) {
// 			        console.error("API Error:", error);
// 			        return {
// 					      success: false,
// 					      message: error?.response?.data?.message || "Something went wrong",
// 					    };
// 			      }
// }

export const fetchApi = (endpoint = null, method = null, variables = null) =>
	axios({
		method: method,
		url: `${process.env.REACT_APP_API_URL}/${endpoint}`,
		data: variables,
		withCredentials: true
	})
		.then((res) => {
			return res.data;
		})
		.catch((error) => {
			console.error("API Error:", error);
			return {
				success: false,
				message: error?.response?.data?.message || "Something went wrong",
			};
		}
		);
